import { Badge as KendoBadge } from '@progress/kendo-react-indicators';

/**
 * Renders Kendo UI Badge component with customizable type, size, shape, and theme color.
 *
 * @component
 * @param {Object} props - component props.
 * @param {React.ReactNode} props.children - content to display inside badge.
 * @param {'default'|'success'|'error'|'info'|'warning'} [props.type='default'] - type of badge.
 * @param {'small'|'medium'|'large'} [props.size='medium'] - size of badge.
 * @param {'rectangle'|'rounded'|'pill'|'circle'} [props.shape='rectangle'] - shape of badge.
 * @param {'primary'|'secondary'|'tertiary'|'info'|'success'|'warning'|'error'} [props.themeColor='primary'] - theme color of badge.
 * @returns {JSX.Element} rendered badge component.
 */
export const Badge = ({ 
  children,
  type = 'default',
  size = 'medium',
  shape = 'rectangle',
  themeColor = 'primary',
}) => {
  return (
    <KendoBadge
      type={type}
      size={size}
      shape={shape}
      themeColor={themeColor}
    >
      {children}
    </KendoBadge>
  );
}